/**
 * Fixed-timestep frame loop, ported from the prototype's frame(): wall-clock
 * elapsed (capped at 100 ms) scaled by the speed setting feeds an accumulator
 * that steps the sim in exact DT increments (max 60/frame). Frame rate can
 * never affect outcomes -- only how many ticks run per frame.
 */
import { DT, SPEEDS } from '../data/balance.js';

export class Loop {
  speedIdx = 0;
  private last = performance.now();
  private simAcc = 0;
  private rafId = 0;

  constructor(
    private readonly running: () => boolean,
    private readonly stepTick: () => void,
    private readonly afterFrame: (elapsed: number, ticksRun: number) => void,
  ) {}

  start(): void {
    this.last = performance.now();
    const frame = (now: number): void => {
      const elapsed = Math.min((now - this.last) / 1000, 0.1);
      this.last = now;
      let ticks = 0;
      if (this.running()) {
        this.simAcc += elapsed * SPEEDS[this.speedIdx]!;
        let guard = 0;
        while (this.simAcc >= DT && guard < 60) {
          this.stepTick();
          this.simAcc -= DT;
          guard++;
          ticks++;
        }
      }
      this.afterFrame(elapsed, ticks);
      this.rafId = requestAnimationFrame(frame);
    };
    this.rafId = requestAnimationFrame(frame);
  }

  stop(): void {
    cancelAnimationFrame(this.rafId);
  }
}
